import * as React from 'react';
import classnames from 'classnames';

import Tooltip from 'components/Tooltip';

import type { DeliverableTagColor } from 'types';

import './deliverable-tag-pill.scss';

type Props = {
  name: string,
  color: DeliverableTagColor,
  size?: 'normal' | 'nano',
  wide?: 'normal' | 'long'
};

const DeliverableTagPill = (
  {
    name,
    color,
    size = 'normal',
    wide = 'normal'
  }: Props
): JSX.Element => {
  const classes = classnames(
    'deliverable-tag-pill',
    'text-overflow-ellipsis',
    `deliverable-tag-pill--color-${String(color)}`,
    `deliverable-tag-pill--size-${String(size)}`,
    `deliverable-tag-pill--wide-${String(wide)}`
  );

  return (
    <Tooltip
      message={name}
      display="flex"
      width="auto-compact"
    >
      <div className={classes}>
        {name}
      </div>
    </Tooltip>
  );
};

export default DeliverableTagPill;
